import { cn } from '@/lib/utils';
import { inputBase } from '@/components/ui/input';

// Shared input styling for post-compose.tsx and post-schedule-row.tsx — a
// standalone module (not exported from post-compose.tsx) so the two files
// can import each other's pieces without a circular dependency.
//
// T12/B2: this is now the ONE input recipe (`inputBase`) plus the compact
// h-9 inspector density — it used to be a hand-rolled copy that had drifted
// from ui/input.tsx on radius, surface and focus treatment.
export const fieldClasses = cn(inputBase, 'h-9 py-1.5');
